import { EApplicantType, EFinancingProgram } from '@if/core/types'
import { Dialog, DialogContent, DialogTitle, Stack } from '@mui/material'
import DialogCloseButton from '@src/components/common/DialogCloseButton'
import FlinksOptionBox from './FlinksOptionBox'
import ManualOptionBox from './ManualOptionBox'

interface Props {
  open: boolean
  onClose: () => void
  applicantType: EApplicantType
  creditApplicationId: string
  canSkipFlinks: boolean
  financingProgramId: EFinancingProgram
}

const BankAccountProcedureDialog = ({
  open,
  onClose,
  applicantType,
  creditApplicationId,
  canSkipFlinks,
  financingProgramId,
}: Props) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg">
      <DialogTitle>
        <DialogCloseButton onClose={onClose} />
      </DialogTitle>
      <DialogContent dividers={false}>
        <Stack justifyContent="center" direction="row" spacing={2}>
          <FlinksOptionBox canSkipFlinks={canSkipFlinks} />
          {canSkipFlinks && (
            <ManualOptionBox
              financingProgramId={financingProgramId}
              creditApplicationId={creditApplicationId}
              applicantType={applicantType}
            />
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  )
}

export default BankAccountProcedureDialog
